import { InstoreOrderLineCustomField } from "../models/instoreOrder";
import normalizeCustomFields from "./normalizeCustomFields";

// Builds the editable perso field list for a basket line: every field the
// template defines (custom_fields = names), pre-filled with any value the user
// already entered (perso_values).
export default function mergePersoFields(
  customFields: string[] | undefined,
  persoValues: InstoreOrderLineCustomField[] | undefined,
): InstoreOrderLineCustomField[] {
  return normalizeCustomFields(customFields).map((field) => ({
    fieldName: field.fieldName,
    fieldValue:
      persoValues?.find((v) => v.fieldName === field.fieldName)?.fieldValue ??
      "",
  }));
}

// A line's perso is complete when it has at least one field and every field has
// a non-empty value.
export function isPersoComplete(
  customFields: string[] | undefined,
  persoValues: InstoreOrderLineCustomField[] | undefined,
): boolean {
  const fields = mergePersoFields(customFields, persoValues);
  if (fields.length === 0) return true;
  return fields.every((f) => f.fieldValue.trim() !== "");
}
